import { useCallback, useState } from "react";

/** A boolean UI preference remembered in localStorage (per browser, best effort). */
export function usePrefFlag(key: string, initial: boolean): [boolean, (v: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const stored = globalThis.localStorage.getItem(key);
      if (stored === "1") return true;
      if (stored === "0") return false;
    } catch {
      // Storage can be blocked; use the default.
    }
    return initial;
  });
  const set = useCallback(
    (v: boolean) => {
      setValue(v);
      try {
        globalThis.localStorage.setItem(key, v ? "1" : "0");
      } catch {
        // Not persisted without storage.
      }
    },
    [key],
  );
  return [value, set];
}
